var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Effect"}},[_c('v-select',{attrs:{"options":_vm.filteredOptions,"searchable":false,"placeholder":"Add motion effect"},model:{value:(_vm.selectedEffectMutation),callback:function ($$v) {_vm.selectedEffectMutation=$$v},expression:"selectedEffectMutation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }